module.exports = __webpack_public_path__ + "img/art1_footer.b2269978.png";